import {
  ChangeCourseItemStatusInput,
  CourseAIBasedCreationInput,
  CourseDetailsModelBase,
  CourseHeirarchyModel,
  CourseHierarchyItemTypeEnum,
  CourseItemStatus,
  CourseLessonItem,
  CourseSettingsModel,
  CreateModuleInput,
  CurriculumAiData,
  GenericCourseItemCreationInput,
  LessonEditInput,
  MoveCourseItemInput,
  SetCourseHeirarchyInput,
  StudentItem,
} from '../../../../../components/user-dashboard/product/models/course';
// actions/products.actions.ts
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';




// Current Product Management
export const CurrentCourseHeirarchyActions = createActionGroup({
  source: 'Load Current Course Heirarchy',
  events: {
    load: props<{ productId: number; errorHandler?: any }>(),
    loadSuccess: props<{ heirarchy: CourseHeirarchyModel }>(),
    loadFailure: props<{ error: any }>(),
    resetProcessingStatus: emptyProps(),
  },
});


export const CreateCourseItemActions = createActionGroup({
  source: 'Create Course Item',
  events: {
    create: props<{
      productId: number;
      itemType: CourseHierarchyItemTypeEnum;
      payload: GenericCourseItemCreationInput;
      errorHandler?: any;
    }>(),
    success: props<{ heirarchy: CourseHeirarchyModel }>(),
    failure: props<{ error: any }>(),
  },
});

export const CurriculumSeedProductActions = createActionGroup({
  source: 'Seed Product',
  events: {
    generate: props<{ courseId: number, courseData: CourseAIBasedCreationInput }>(),
    generateSuccess: props<{ courseId: number, heirarchy: any }>(),
    generateFailure: props<{ error: any }>(),
  },
});

export const GenerateCourseAiHierarchyActions = createActionGroup({
  source: 'Generate Course Ai Hierarchy',
  events: {
    generate: props<{ courseId: number, courseData: { apply: boolean, aiState: { curriculumAiData: CurriculumAiData } } }>(),
    generateSuccess: props<{ courseId: number, heirarchy: any }>(),
    generateFailure: props<{ error: any }>(),
  },
});

export const GenerateLessonAiContentActions = createActionGroup({
  source: 'Generate Lesson Content Ai',
  events: {
    generateAll: props<{ courseId: number, justCheck?: boolean }>(),
    generate: props<{ courseId: number, lessonId: number }>(),
    generateUpdate: props<{ courseId: number, lessonId: number, completed: number, total: number }>(),
    generateSuccess: props<{ courseId: number, lessonId: number | null }>(),
    generateFailure: props<{ courseId: number, error: any }>(),
  },
});


export const ApplyTemplateToCourseAction = createActionGroup({
  source: 'Apply Template To Course Heirarchy',
  events: {
    set: props<{
      productId: number;
      payload: SetCourseHeirarchyInput;
      errorHandler?: any;
    }>(),
    success: props<{ heirarchy: CourseHeirarchyModel }>(),
    failure: props<{ error: any }>(),
  },
});


export const UpdateCourseSettingsActions = createActionGroup({
  source: 'Update Course Settings',
  events: {
    update: props<{
      productId: number;
      payload: CourseSettingsModel;
      errorHandler?: any;
    }>(),
    success: props<{ heirarchy: CourseHeirarchyModel }>(),
    failure: props<{ error: any }>(),
  },
});


// Current Product Update
export const MoveCourseItemActions = createActionGroup({
  source: 'Update Current Course Heirarchy',
  events: {
    move: props<{
      productId: number;
      payload: MoveCourseItemInput;
      errorHandler?: any;
    }>(),
    moveSuccess: props<{ heirarchy: CourseHeirarchyModel }>(),
    moveFailure: props<{ error: any }>(),
  },
});


// Generic
export const updateCurrentCourseHeirarchyStructure = createAction(
  '[Course] Update Current Course Heirarchy Structure',
  props<{ heirarchy: CourseHeirarchyModel }>()
);

export const clearCurrentCourse = createAction(
  '[Course] Clear Current Course Data'
);
